module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/patient_recommends/img_avatar_03-a7a5fe0a55028ec093e19fa25746a23b.png";